var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",class:_vm.containerClass},[_c('transition-group',{attrs:{"name":"p-toast-message","tag":"div"},on:{"enter":_vm.onEnter}},_vm._l((_vm.messages),function(msg){return _c('ToastMessage',{key:msg.id,attrs:{"message":msg,"templates":_vm.$scopedSlots},on:{"close":function($event){return _vm.remove($event)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }